module.exports = __webpack_public_path__ + "static/media/svg-2.ae858aa2.svg";